/* eslint-disable max-lines */
import axios from 'axios';
import { productTypeMapping } from './productTypeMapping';
import {
  createSourceInformation,
  createDocumentProofsArray,
  returnOccupationInEN,
} from './formServiceUtils';
import { dgiMapping } from './dgiMapping';
import { dgiContMapping } from './dgiContMapping';
import { EXISTING_USER, NEW_USER, SALES } from '../constants';
import {
  commonUtility,
  formattedDepositAmount,
} from '../components/LeadGeneration/UtilityFunctions';
import { bankName, fundingAccount } from './formService';
import { commonTernary } from '../components/commonCode';

export const saveDgiFundingInfo = async (data, dgidata, accessToken) => {
  const formData = {
    Event: 'CaptureFundingInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: [
        ...(dgiContMapping(data.productName) === 'DGI Contribution'
          ? [
              {
                ProductType: productTypeMapping(data.productType),
                ProductName: dgiContMapping(data.productName),
                FundingInfo: {
                  FundingType: fundingAccount(data),
                  BankName: bankName(data),
                  AccountNumber: commonUtility(data.accountNumber),
                  DGIAccountNumber: commonUtility(data.dgiAccountNumber),
                  AccountType: commonUtility(data.typeOfAccount),
                  TransitNumber:
                    commonUtility(data.transitNumber) === 'Other'
                      ? data.customTransitNumber
                      : data.transitNumber,
                  DepositAmount: formattedDepositAmount(data.depositAmount),
                  IsAccountBelongsToYou:
                    fundingAccount(data) === 'AnotherBankAccount'
                      ? commonUtility(data.isAccountBelongsToYou)
                      : null,
                  TaxYear: commonUtility(data.taxYear),
                  Documents: createDocumentProofsArray(
                    data.statementDocumentId,
                    'Check/Bank Statement'
                  ),
                },
                Category: 'Primary',
              },
            ]
          : [
              {
                ProductType: productTypeMapping(data.productType),
                ProductName: dgiMapping(data.productName),
                FundingInfo: {
                  FundingType: fundingAccount(data),
                  BankName: bankName(data),
                  AccountNumber: commonUtility(data.accountNumber),
                  AccountType: commonUtility(data.typeOfAccount),
                  TransitNumber: commonTernary(
                    commonUtility(data.transitNumber) === 'Other',
                    data.customTransitNumber,
                    data.transitNumber
                  ),
                  DepositAmount: formattedDepositAmount(data.depositAmount),
                  TaxYear: commonUtility(data.taxYear),
                  IsAccountBelongsToYou:
                    fundingAccount(data) === 'AnotherBankAccount'
                      ? commonUtility(data.isAccountBelongsToYou)
                      : null,
                  Documents: createDocumentProofsArray(
                    data.statementDocumentId,
                    'Check/Bank Statement'
                  ),
                },
                Category: 'Primary',
              },
              ...(data.productName === 'Elite Account'
                ? [
                    {
                      ProductType:
                        data.productName === 'Elite Account'
                          ? 'Savings Account'
                          : productTypeMapping(data.productType),
                      ProductName: dgiMapping(data.productName),
                      FundingInfo: {
                        FundingType: fundingAccount(data),
                        BankName: bankName(data),
                        AccountNumber: commonUtility(data.accountNumber),
                        AccountType: commonUtility(data.typeOfAccount),
                        TransitNumber: commonTernary(
                          commonUtility(data.transitNumber) === 'Other',
                          data.customTransitNumber,
                          data.transitNumber
                        ),
                        DepositAmount: formattedDepositAmount(data.depositAmount),
                        TaxYear: commonUtility(data.taxYear),
                        IsAccountBelongsToYou:
                          fundingAccount(data) === 'AnotherBankAccount'
                            ? commonUtility(data.isAccountBelongsToYou)
                            : null,
                        Documents: createDocumentProofsArray(
                          data.statementDocumentId,
                          'Check/Bank Statement'
                        ),
                      },
                      Category: 'Secondary',
                    },
                  ]
                : []),
            ]),
      ],
      Applicants: [
        {
          FinancialInfo: {
            LiquidNetWorth: commonUtility(dgidata?.liquidNetWorth),
            NetWorth: commonUtility(dgidata?.netWorth),
            TaxBracket: commonUtility(dgidata?.taxBracket),
          },
          GeneralInvestmentInfo: {
            Equities: commonUtility(dgidata?.experienceInEquities),
            GeneralInvestmentKnowledge: commonUtility(dgidata?.investmentKnowledge),
            MutualFund: commonUtility(dgidata?.experienceInMutualFunds),
            FixedIncome: commonUtility(dgidata?.experienceInFixedIncome),
            InvestmentObjective: commonUtility(dgidata?.investmentObjective),
            RiskTolerance: commonUtility(dgidata?.riskTolerance),
            LiquidityNeeds: commonUtility(dgidata?.liquidityNeeds),
            AssetTimeHorizon: commonUtility(dgidata?.assetTimeHorizon),
          },

          ApplicantCategory: 'Primary',
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
export const saveDgiContFundingInfo = async (data, dgidata, accessToken) => {
  const formData = {
    Event: 'CaptureFundingInfo',
    Application: {
      ApplicationID: data.applicationId,
      TemplateVersion: '2021-08-05',
      Source: createSourceInformation(data),
      Products: [
        {
          ProductType: productTypeMapping(data.productType),
          ProductName: dgiContMapping(data.productName),
          FundingInfo: {
            FundingType: fundingAccount(data),
            BankName: bankName(data),
            AccountNumber: commonUtility(data.accountNumber),
            DGIAccountNumber: commonUtility(data.dgiAccountNumber),
            AccountType: commonUtility(data.typeOfAccount),
            TransitNumber: commonTernary(
              commonUtility(data.transitNumber) === 'Other',
              data.customTransitNumber,
              data.transitNumber
            ),
            DepositAmount: formattedDepositAmount(data.depositAmount),
            TaxYear: commonUtility(data.taxYear),
            Documents: createDocumentProofsArray(data.statementDocumentId, 'Check/Bank Statement'),
          },
          Category: 'Primary',
        },
        ...(data.productName === 'Elite Account'
          ? [
              {
                ProductType:
                  data.productName === 'Elite Account'
                    ? 'Savings Account'
                    : productTypeMapping(data.productType),
                ProductName: dgiContMapping(data.productName),
                FundingInfo: {
                  FundingType: fundingAccount(data),
                  BankName: bankName(data),
                  AccountNumber: commonUtility(data.accountNumber),
                  DGIAccountNumber: commonUtility(data.dgiAccountNumber),
                  AccountType: commonUtility(data.typeOfAccount),
                  TransitNumber: commonTernary(
                    commonUtility(data.transitNumber) === 'Other',
                    data.customTransitNumber,
                    data.transitNumber
                  ),
                  DepositAmount: formattedDepositAmount(data.depositAmount),
                  TaxYear: commonUtility(data.taxYear),
                  Documents: createDocumentProofsArray(
                    data.statementDocumentId,
                    'Check/Bank Statement'
                  ),
                },
                Category: 'Secondary',
              },
            ]
          : []),
      ],
      Applicants: [
        {
          FinancialInfo: {
            TaxBracket: commonUtility(dgidata?.taxBracket),
            NetWorth: commonUtility(dgidata?.netWorth),
            LiquidNetWorth: commonUtility(dgidata?.liquidNetWorth),
          },
          GeneralInvestmentInfo: {
            LiquidityNeeds: commonUtility(dgidata?.liquidityNeeds),
            Equities: commonUtility(dgidata?.experienceInEquities),
            AssetTimeHorizon: commonUtility(dgidata?.assetTimeHorizon),
            FixedIncome: commonUtility(dgidata?.experienceInFixedIncome),
            RiskTolerance: commonUtility(dgidata?.riskTolerance),
            MutualFund: commonUtility(dgidata?.experienceInMutualFunds),
            GeneralInvestmentKnowledge: commonUtility(dgidata?.investmentKnowledge),
            InvestmentObjective: commonUtility(dgidata?.investmentObjective),
          },
          ApplicantCategory: 'Primary',
        },
      ],
      Processing: { CaseReference: [] },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
export const saveFinanceInfo = async (data, dgidata, accessToken) => {
  const formData = {
    Event: 'CaptureFinancialInfo',
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : null,
      TemplateVersion: '2021-08-05',
      Source: {
        Language: data.language ? data.language : null,
        Location: data.Location ? data.Location : null,
      },
      Applicants: [
        {
          EmploymentInformation: {
            AnnualIncome: data.annualIncome ? data.annualIncome : null,
            EmploymentStatus: commonUtility(dgidata.empStatus),
          },
          FinancialInfo: {
            NetWorth: commonUtility(data.netWorth),
            LiquidNetWorth: data.liquidNetWorth ? data.liquidNetWorth : null,
            TaxBracket: data.taxBracket ? data.taxBracket : null,
          },
          GeneralInvestmentInfo: {
            GeneralInvestmentKnowledge: data.investmentKnowledge ? data.investmentKnowledge : null,
            Equities: data.experienceInEquities ? data.experienceInEquities : null,
            FixedIncome: data.experienceInFixedIncome ? data.experienceInFixedIncome : null,
            MutualFund: data.experienceInMutualFunds ? data.experienceInMutualFunds : null,
            RiskTolerance: data.riskTolerance ? data.riskTolerance : null,
            InvestmentObjective: data.investmentObjective ? data.investmentObjective : null,
            AssetTimeHorizon: data.assetTimeHorizon ? data.assetTimeHorizon : null,
            LiquidityNeeds: data.liquidityNeeds ? data.liquidityNeeds : null,
          },

          ApplicantCategory: 'Primary',
        },
      ],
      Processing: {
        CaseReference: [],
      },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
const addressDetails = (datadgi) => {
  if (
    datadgi?.address1 ||
    datadgi?.city ||
    datadgi?.state ||
    datadgi?.country ||
    datadgi?.zipCode
  ) {
    return {
      Address: {
        LineOne: commonUtility(datadgi?.address1),
        AddrCity: commonUtility(datadgi?.city),
        AddrState: commonUtility(datadgi?.state),
        AddrCountry: commonUtility(datadgi?.country),
        ZipCode: commonUtility(datadgi?.zipCode),
      },
    };
  }
};
export const saveAdditionalInfo = async (data, datadgi, accessToken) => {
  const formData = {
    Event: 'CaptureComplianceInfo',
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : null,
      TemplateVersion: '2021-08-05',
      Source: {
        Language: commonUtility(data.language),
        Location: commonUtility(data.Location),
      },
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          EmploymentInformation: {
            EmploymentStatus: commonUtility(datadgi?.empStatus),
            Employer: commonUtility(datadgi?.employer),
            Occupation: datadgi?.occupation ? returnOccupationInEN(datadgi?.occupation) : null,
            Reason: commonUtility(datadgi?.reason),
            SchoolName: commonUtility(datadgi?.schoolName),
            SourceOfCurrentIncome: commonUtility(datadgi?.sourceOfCurrentIncome),
            PreviousEmployer: commonUtility(datadgi?.previousEmployer),
            EmploymentTimePeriod: commonUtility(datadgi?.years),
            ...(datadgi.empStatus === 'Employed' || datadgi.empStatus === 'Self Employed'
              ? addressDetails(datadgi)
              : null),
          },
          ComplianceQuestions: [
            {
              Name: 'AreEngaged',
              Description: 'Some questions we are required to ask:',
              Answer: {
                Type: 'boolean',
                Value: 'false',
              },
            },
            {
              Name: 'IsPoliticallyExposed',
              Description:
                'Are you a Politically Exposed Person or are you related to a Politically Exposed Person?',
              Answer: {
                Type: 'boolean',
                Value: data.poli ? 'true' : 'false',
              },
            },
            {
              Name: 'IsSpecifiedAdult',
              Description: 'Are you a Specified Adult?',
              Answer: {
                Type: 'boolean',
                Value: data.adu ? 'true' : 'false',
              },
            },
            {
              Name: 'IsTrustedContactInfo',
              Description: 'Do you want to provide information for a Trusted Contact?',
              Answer: {
                Type: 'boolean',
                Value: data.trust ? 'true' : 'false',
              },
            },
          ],
        },
        ...(data.trust
          ? [
              {
                ApplicantType: null,
                ApplicantCategory: 'TrustedContact',
                FullName: commonUtility(data?.fullName),
                Identifications: [
                  {
                    IdenDOB: data.dob ? data?.dob : '',
                  },
                ],
                Contacts: [
                  {
                    ContactType: 'mobile',
                    ContactValue: data.phone ? `(${data.areaCode}) ${data.phone}` : null,
                  },
                ],
                Addresses: [
                  {
                    AddrType: 'mailing',
                    LineOne: commonUtility(data?.address1),
                    AddrCity: commonUtility(data?.city),
                    AddrState: commonUtility(data?.state),
                    AddrCountry: commonUtility(data?.country),
                    ZipCode: commonUtility(data?.zipCode),
                  },
                ],
              },
            ]
          : []),
      ],

      Processing: {
        CaseReference: [],
      },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
let value;
export const saveEdeliveryInfo = async (data, accessToken) => {
  const anserValExistingUserID = () => {
    if (data.onlineUserToggle) {
      if (data.selectedUserType === EXISTING_USER) {
        value = 'true';
      } else {
        value = 'false';
      }
    } else {
      value = 'false';
    }
    return value;
  };
  const formData = {
    Event: 'CaptureEDeliveryInfo',
    Application: {
      ApplicationID: data.applicationId ? data.applicationId : null,
      TemplateVersion: '2021-07-02',
      Source: {
        Language: commonUtility(data.language),
        Location: commonUtility(data.location),
        UtmSource: null,
        UtmMedium: null,
        UtmCampaign: null,
        UtmContent: null,
        UtmTerm: null,
      },
      Applicants: [
        {
          ApplicantCategory: 'Primary',
          ElectronicDelivery: [
            {
              Name: 'OnLineEDeivery',
              Description:
                'For your convenience, account communications will be delivered to you electronically.',
              Answer: {
                Type: 'boolean',
                Value: data.onlineUserToggle ? 'true' : 'false',
              },
            },
            {
              Name: 'ExistingUserID',
              Description: 'Do you have a existing user ID?',
              Answer: {
                Type: 'boolean',
                Value: anserValExistingUserID(),
              },
              FormData: {
                UserID: commonUtility(data.existingUserId),
              },
            },
            {
              Name: 'NewUserID',
              Description:
                'Please provide 2 user ID options. You will receive and email confirmation of enrollment once your account setup is completed.',
              Answer: {
                Type: 'boolean',
                Value: data.selectedUserType === NEW_USER ? 'true' : 'false',
              },
              FormData: {
                UserIDOption1: commonUtility(data.userId1),
                UserIDOption2: commonUtility(data.userId2),
              },
            },
          ],
        },
      ],
      Processing: {
        CaseReference: [{}],
      },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};
